export const metadataOptions = (metadata, apiName) => {
  const selectArray = [];
  const selectPicklist = metadata.find(item => item.api_name === apiName).pick_list_values;
  selectPicklist.map(item => selectArray.push({ value: item.display_value, label: item.display_value }));
  return selectArray;
};

export const selectStyles = {
  dropdownIndicator: provided => ({
    ...provided,
    bg: 'transparent',
    px: 2,
    cursor: 'inherit',
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none',
  }),
  control: provided => ({
    ...provided,
    borderRadius: '48px',
    backgroundColor: 'gray.50',
    borderColor: 'gray.200',
  }),
  multiValue: provided => ({
    ...provided,
    borderRadius: '20px',
    backgroundColor: 'blue.200',
    fontSize: '14px',
    fontWeight: '700',
    color: 'blue.500',
    padding: '4px 16px',
  }),
  option: provided => ({
    ...provided,
    fontSize: '14px',
    fontWeight: '700',
    color: 'blue.500',
    ':hover': {
      backgroundColor: 'blue.200',
    },
  }),
};

export const experienceLevelStyles = {
  control: provided => ({
    ...provided,
    borderRadius: '48px',
    borderColor: 'gray.200',
    fontSize: '14px',
    fontWeight: '500',
    backgroundColor: 'gray.50',
  }),
  option: (provided, { data }) => ({
    ...provided,
    fontSize: '14px',
    fontWeight: '500',
    color: data.colors?.color,
    backgroundColor: data.colors?.bgColor,
    ':hover': {
      filter: 'brightness(95%)',
    },
  }),
  valueContainer: (provided, { getValue }) => ({
    ...provided,
    color: getValue()[0].colors?.color,
    backgroundColor: getValue()[0].colors?.bgColor,
    cursor: 'pointer',
  }),
  dropdownIndicator: (provided, { getValue }) => ({
    ...provided,
    color: getValue()[0].colors?.color,
    backgroundColor: getValue()[0].colors ? getValue()[0].colors.bgColor : 'gray.50',
    px: 2,
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none',
  }),
};

const itemStyle = imageUrl => ({
  alignItems: 'center',
  display: 'flex',
  fontSize: '14px',
  fontWeight: '700',
  color: 'blue.500',

  ':before': {
    borderRadius: 10,
    content: '" "',
    display: 'block',
    minHeight: 10,
    minWidth: 10,
    backgroundImage: imageUrl,
    backgroundSize: 'cover',
    marginRight: '12px',
  },
});

export const impersonateStyles = {
  dropdownIndicator: provided => ({
    ...provided,
    bg: 'transparent',
    px: 2,
    cursor: 'inherit',
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none',
  }),
  control: provided => ({
    ...provided,
    borderRadius: '48px',
    backgroundColor: 'gray.50',
    borderColor: 'gray.200',
  }),
  valueContainer: provided => ({
    ...provided,
    cursor: 'pointer',
  }),
  option: (styles, { data, _isDisabled, _isFocused, isSelected }) => ({
    ...styles,
    ...itemStyle(data.imageUrl),
    backgroundColor: isSelected ? 'blue.200' : undefined,
    ':hover': {
      backgroundColor: 'blue.200',
    },
  }),
  singleValue: (styles, { data }) => ({
    ...styles,
    ...itemStyle(data.imageUrl),
  }),
};
